export default __webpack_public_path__ + "static/media/DSC_8037.7a15dbe7.jpg";